import { render } from "./BoardSpaceTile.vue?vue&type=template&id=1aa59d53&ts=true"
import script from "./BoardSpaceTile.vue?vue&type=script&lang=ts"
export * from "./BoardSpaceTile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__